import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useMutation } from 'react-query';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useStore } from 'hooks/useRootStore';
import { CountryForm } from 'components/Forms/CountryForm/CountryForm';
import { AppLoader } from 'components/Core/AppLoader';
import { CountriesTransFields } from 'containers/Countries/types';
import { countriesTranslations } from 'containers/Countries/translations';
import styles from './country.module.scss';

const Country: FC = () => {
  const {
    countriesStore: { countryData, getCountryData },
  } = useStore();

  const { t } = useMyTranslations<CountriesTransFields>([countriesTranslations.name]);

  const { id } = useParams();
  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation(getCountryData, {
    mutationKey: 'getCountryData',
    onError: () => navigate('/countries'),
  });

  useEffect(() => {
    !countryData && id && mutate(id);
  }, [id, countryData]);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t(id ? 'titleEdit' : 'titleAdd')}</h2>
      </header>
      <div className={styles.container}>{isLoading ? <AppLoader /> : <CountryForm />}</div>
    </main>
  );
};

export default observer(Country);
